module.exports = "../images/icons-race-details/Percorso.svg";